import { render } from "./Bolt.vue?vue&type=template&id=ca17f546&bindings={}"
import script from "./Bolt.vue?vue&type=script&lang=ts"
export * from "./Bolt.vue?vue&type=script&lang=ts"
script.render = render

export default script